// @ts-nocheck
import React, {useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: "16px",
        },
    },
}));

export default function AlertMessage(props) {
    const { alert, setAlert } = props;
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const status = alert && alert.status? props.alert.status : "info";
    const message = alert && alert.message? props.alert.message : "";

    const handleClick = () => {
        setAlert(null);
    };

    useEffect(() => {
        setOpen(alert !== null);
    }, [setOpen, alert]);

    useEffect(() => {
        const timer1 = setTimeout(() => {setOpen(false)}, 7000);
        const timer2 = setTimeout(() => {setAlert(null)}, 7500);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alert])

    return (
        <div className={classes.root}>
          <Collapse in={open}>
              <Alert
                  severity={status}
                  action={
                      <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={handleClick}
                      >
                          <CloseIcon fontSize="inherit" />
                      </IconButton>
                  }
              >
                  {message}
              </Alert>
          </Collapse>
            {open ? <br/> : ''}
      </div>
    );
}